import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-foreground-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">韩漫画网</span>
            </div>
            <p className="text-sm text-foreground-200 leading-relaxed">
              海量正版漫画在线阅读平台，设有免费漫画弹窗入口，内容安全可靠，让您安心享受高质量漫画资源。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/lianai" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/dongzuo" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/xuanyi" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">悬疑漫画</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">搞笑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#faq" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-200">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@hanmanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-200">
                <i className="ri-wechat-line text-primary-400"></i>
                <span>hanmanhua_official</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-200">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-300">
            &copy; 2023-2026 韩漫画网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-300">
            本站所有漫画均为正版授权，内容安全可靠
          </p>
        </div>
      </div>
    </footer>
  );
}